import React from "react";
import styled from "styled-components";
import { Button, Modal } from "components";
import { useTranslation } from "react-i18next";

import { theme } from "theme/theme";

const ModalStyled = styled(Modal)`
  .ant-modal-body {
    padding: 20px 16px 1px;
    text-align: center;
    > div {
      line-height: 40px;
    }
  }
  .ant-modal-footer {
    padding: 0px 16px 20px;
    border: unset;
  }
  div {
    line-height: 16px;
  }
  ${theme.media.tablet} {
    .ant-modal-body {
      padding: 32px 24px 1px 24px;
    }
    .ant-modal-footer {
      padding: 0px 24px 32px;
    }
  }
`;

const WrapperBtnFooter = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    width: 144px;
  }
  button:last-child {
    width: 151px;
  }
  ${theme.media.tablet} {
    justify-content: center;
    gap: 40px;
    button {
      width: 128px !important;
    }
  }
`;

interface IConfirmModal {
  isVisible: boolean;
  close: () => void;
  ok: () => void;
  children: React.ReactNode;
  background?: string;
}

const ConfirmModal: React.FC<IConfirmModal> = ({
  isVisible,
  close,
  ok,
  children,
  background = "#FB4E4E",
}) => {
  const { t }: any = useTranslation("translation", { keyPrefix: "user-list" });

  return (
    <ModalStyled
      type="confirm"
      footer={
        <WrapperBtnFooter>
          <Button
            onClick={close}
            background="#E0E0E0"
            color="#fff"
            name={t("cancel")}
            border="none"
            bdr="6px"
            fontSize={16}
            fontWeight={700}
            lineHeight="16px"
            padding="12px 24px"
          />

          <Button
            onClick={ok}
            background={background}
            color="#fff"
            name={t("yes")}
            border="none"
            bdr="6px"
            fontSize={16}
            fontWeight={700}
            lineHeight="16px"
            padding="12px 48px"
          />
        </WrapperBtnFooter>
      }
      visible={isVisible}
    >
      {children}
    </ModalStyled>
  );
};

export default ConfirmModal;
